export default {
    title: 'ការរម្លឹកឡើងវិញម្ដងទៀតរបស់ 1Byte',
    unrenewed_service: {
        title: 'សេវាកម្មមិនត្រូវបានបន្ដឡើយ',
    },
    unpaid_invoice: {
        title: 'វិក្កយបត្រមិនទាន់បានបង់នៅឡើយទេ',
    },
};
